// frontend/src/components/OwnerDashboard/AgendaList.js
// Next deadlines, derived from vehicle dates — never hardcoded copy.

import { signal } from '../../theme/iparc';
import { isExpired, oilRemaining } from '../../hooks/useFleetHealth';

const MONTHS = ['Janv', 'Févr', 'Mars', 'Avr', 'Mai', 'Juin', 'Juil', 'Août', 'Sept', 'Oct', 'Nov', 'Déc'];

const daysUntil = (d) => Math.ceil((new Date(d) - Date.now()) / 864e5);

const relative = (days) => {
  if (days < 0) return `en retard de ${Math.abs(days)} j`;
  if (days === 0) return "aujourd'hui";
  if (days === 1) return 'demain';
  return `dans ${days} jours`;
};

export function buildAgenda(vehicles, limit = 4) {
  const items = [];

  vehicles.forEach((v) => {
    [['technicalCheck', 'Contrôle technique'], ['insurance', 'Assurance']].forEach(([key, label]) => {
      const date = v[key]?.expiry;
      if (!date || isExpired(date)) return;
      const days = daysUntil(date);
      items.push({
        id: `${v._id}-${key}`, date: new Date(date), sort: days,
        title: `${label} — ${v.plateNumber}`,
        note: relative(days),
        color: days <= 30 ? signal.warn : '#8F877B',
      });
    });

    const remaining = oilRemaining(v);
    if (remaining !== null && remaining > 0 && remaining <= 2000) {
      items.push({
        id: `${v._id}-oil`, date: null, sort: 1000 + remaining / 100,
        title: `Vidange prévue — ${v.plateNumber}`,
        note: `${remaining.toLocaleString('fr-FR')} km restants`,
        color: remaining <= 500 ? signal.warn : '#8F877B',
      });
    }
  });

  return items.sort((a, b) => a.sort - b.sort).slice(0, limit);
}

export default function AgendaList({ vehicles, onSeeCalendar, className = '' }) {
  const items = buildAgenda(vehicles);

  return (
    <div className={`flex flex-col rounded-2xl border border-[#241F1B] bg-gradient-to-b from-[#17140F] to-[#131110] overflow-hidden ${className}`}>
      <header className="flex items-center justify-between px-[18px] py-3.5 border-b border-[#241F1B]">
        <p className="text-[10.5px] uppercase tracking-[.16em] text-[#6E665C]">Prochaines échéances</p>
        <button onClick={onSeeCalendar} className="text-[11px] text-[#8F877B] hover:text-[#F4F1EA] transition-colors">
          Calendrier
        </button>
      </header>

      {items.length === 0 ? (
        <p className="px-[18px] py-5 text-[12px] text-[#6E665C]">Aucune échéance dans les prochaines semaines.</p>
      ) : (
        <ul className="py-1.5">
          {items.map((e) => (
            <li key={e.id} className="flex gap-3 px-[18px] py-2.5 items-center hover:bg-[#1A1613] transition-colors">
              <div className="text-center w-8 shrink-0">
                <div className="font-['Space_Grotesk',sans-serif] text-[15px] font-semibold leading-none tabular-nums text-[#F4F1EA]">
                  {e.date ? String(e.date.getDate()).padStart(2, '0') : '—'}
                </div>
                <div className="text-[9px] uppercase tracking-[.08em] text-[#6E665C] mt-0.5">
                  {e.date ? MONTHS[e.date.getMonth()] : 'km'}
                </div>
              </div>
              <span className="w-px self-stretch bg-[#241F1B]" />
              <div className="flex-1 min-w-0">
                <p className="text-[12.5px] text-[#F4F1EA] truncate">{e.title}</p>
                <p className="text-[11px] mt-0.5" style={{ color: e.color }}>{e.note}</p>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
